// extracted by mini-css-extract-plugin
export default {"letterPage":"LettersPage_letterPage__Ph2IW","lettersGrid":"LettersPage_lettersGrid__XIvam","letter":"LettersPage_letter__TSN8I","receivedLetter":"LettersPage_receivedLetter__7xI5L"};